export const SHOW_AVATAR_MODAL_EVENT = "show-avatar-modal";
